import Cookies from 'js-cookie';

const getJWTToken = () => Cookies.get('Bearer');

export default {
  getJWTToken,
};
